import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { CurrencyService } from '../services/currency.service';
import { DomSanitizer } from '@angular/platform-browser';



@Pipe({
    name: 'currencyFormat',
    pure: false
})
export class CurrencyFormatPipe implements PipeTransform {
    currencyPipe: CurrencyPipe = new CurrencyPipe(this.locale);

    constructor(
        @Inject(LOCALE_ID) private locale: string,
        private service: CurrencyService,
        private _sanitizer: DomSanitizer
    ) { }

    transform(
        value: any,
        currencyCode?: string,
        display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
        digitsInfo?: string,
        locale?: string
    ): string | null {
        currencyCode = currencyCode || this.service.options.code;
        display = display || this.service.options.display;
        digitsInfo = digitsInfo || this.service.options.digitsInfo;
        locale = locale || this.service.options.locale;

        const form = this.currencyPipe.transform(value, currencyCode, display, digitsInfo, locale);
        const termsApply = form + '<span>تومان</span>';
        // // console.log(form);
        // const regex = /\d+/g;
        // const matches = form?.match(regex);  // creates array from matches

        // if (matches) {
        //     // There is a digit in the string.
        //     console.log('matches:' + matches);
        //     console.log('code:' + currencyCode);
        //     console.log('style A :' + matches + ' ' + currencyCode);
        //     console.log('style B :' + currencyCode + ' ' + matches);

        // } else {
        //     // No Digits found in the string.
        // }

        // return this._sanitizer.bypassSecurityTrustHtml(termsApply);
        return form; // .replace('تومان', '<span>تومان</span>');
    }
}
